import { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import apiClient from '../api/apiClient';
import Logo from '../components/common/Logo';

const ResetPassword = () => {
    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const { token } = useParams();
    const navigate = useNavigate();

    const { password, confirmPassword } = formData;

    const onChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError('Les mots de passe ne correspondent pas.');
            return;
        }

        if (password.length < 8) {
            setError('Le mot de passe doit contenir au moins 8 caractères.');
            return;
        }

        if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
            setError('Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre.');
            return;
        }

        setLoading(true);

        try {
            await apiClient.post(`/auth/reset-password/${token}`, { password });
            setSuccess(true);
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            const message =
                err.response?.data?.message || 'Une erreur est survenue. Veuillez réessayer.';
            setError(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container page-transition">
            <div className="auth-card">
                {success ? (
                    <>
                        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                            <div style={{ fontSize: '48px', marginBottom: '16px' }}>&#10003;</div>
                            <h1 className="auth-title">Mot de passe réinitialisé</h1>
                            <p className="auth-subtitle">
                                Votre mot de passe a été changé avec succès.
                                Redirection vers la connexion...
                            </p>
                        </div>
                        <Link
                            to="/login"
                            className="btn btn-primary"
                            style={{ width: '100%', padding: '15px', display: 'block', textAlign: 'center', textDecoration: 'none' }}
                        >
                            Se connecter
                        </Link>
                    </>
                ) : (
                    <>
                        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
                                <Logo size="large" showText={false} variant="auth" />
                            </div>
                            <p className="auth-subtitle">
                                Choisissez un nouveau mot de passe pour votre compte.
                            </p>
                        </div>

                        {error && (
                            <div style={{
                                background: 'var(--urgent, #E63946)',
                                color: 'white',
                                padding: '12px 16px',
                                borderRadius: '8px',
                                marginBottom: '16px',
                                fontSize: '14px'
                            }}>
                                {error}
                            </div>
                        )}

                        <form onSubmit={onSubmit}>
                            <div className="input-group">
                                <label className="input-label" htmlFor="password">Nouveau mot de passe</label>
                                <input
                                    type="password"
                                    className="input-field"
                                    id="password"
                                    name="password"
                                    value={password}
                                    placeholder="Minimum 8 caractères"
                                    onChange={onChange}
                                    required
                                />
                            </div>

                            <div className="input-group" style={{ marginBottom: '30px' }}>
                                <label className="input-label" htmlFor="confirmPassword">Confirmer le mot de passe</label>
                                <input
                                    type="password"
                                    className="input-field"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    value={confirmPassword}
                                    placeholder="Retapez le mot de passe"
                                    onChange={onChange}
                                    required
                                />
                            </div>

                            <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginBottom: '16px' }}>
                                Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre.
                            </p>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ width: '100%', padding: '15px' }}
                                disabled={loading}
                            >
                                {loading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
                            </button>
                        </form>

                        <div className="auth-footer" style={{ textAlign: 'center', marginTop: '16px' }}>
                            <Link to="/login" style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                                Retour à la connexion
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ResetPassword;
